export default "/images/vendor/@coreui/icons/svg/flag/cif-bi.svg?b02f830933c3c136210b2ca91a941363";